import { useState, useEffect } from 'react';
import './App.scss';
import { Routes, Route } from 'react-router-dom';
import Contact from './pages/Contact.jsx';
import About from './pages/About.jsx';
import ImageGallery from './pages/ImageGallery.jsx';
import Home from './pages/Home.jsx';
import SideNav from './components/SideNav.jsx';


function App() {
  const [theme, setTheme] = useState('dark');
  const [s, setS] = useState(false);
  const [clicks, setClicks] = useState(0);

  useEffect(() => {
    const storedTheme = localStorage.getItem('theme');
    if (storedTheme) {
      setTheme(storedTheme);
    }
  }, []);

  useEffect(() => {
    document.querySelector('.App')?.setAttribute('data-theme', theme);
  }, [theme]);

  function toggleTheme() {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
  };

  return (
    <div className="App" data-theme={theme}>
      <SideNav theme={theme} toggleTheme={toggleTheme} />
      <div className="page-container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gallery" element={<ImageGallery />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
